import { render, staticRenderFns } from "./GroupOfAccreditationCreateEdit.vue?vue&type=template&id=35286ca0&scoped=true"
import script from "./GroupOfAccreditationCreateEdit.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationCreateEdit.vue?vue&type=style&index=0&id=35286ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35286ca0",
  null
  
)

export default component.exports